// extracted by mini-css-extract-plugin
module.exports = {"main":"Todo_main__2O9Dn","container":"Todo_container__2jFfZ","title":"Todo_title__1mIki"};